import { createSlice } from '@reduxjs/toolkit';

const initialState = {};
export const candidateNavigationSlice = createSlice({
  name: 'candidateNavigation',
  initialState,
  reducers: {
    updateCandidateNavigation: (state, action) => action.payload,
  },
});

// Action creators are generated for each case reducer function
export const { updateCandidateNavigation } = candidateNavigationSlice.actions;

export default candidateNavigationSlice.reducer;
